import {
  ON_SET_ADVANCED_PARAMETER_REQUEST,
  ON_SET_ADVANCED_PARAMETER_SUCCESS,
  ON_SET_ADVANCED_PARAMETER_FAILED,
} from '../actionTypes/advancedParameter.actionTypes';

const advancedParameterInitialState = {
  loading: true,
  data: {},
  error: null,
};

const advancedParameterReducer = (state = advancedParameterInitialState, action: any) => {
  switch (action.type) {
    case ON_SET_ADVANCED_PARAMETER_REQUEST:
      return { ...state, loading: true };
    case ON_SET_ADVANCED_PARAMETER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case ON_SET_ADVANCED_PARAMETER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default advancedParameterReducer;
